import { all, takeEvery, select, call, put } from 'redux-saga/effects';
import { BIEventData, BiEventType } from '@wix/da-shared-react/pkg/biLogger';
import { logPageView } from '@wix/da-shared-react/pkg/biLogger/redux/actions';
import { logBiEvent } from '@wix/da-shared-react/pkg/biLogger/redux/saga';
import { selectors } from '@wix/da-shared-react/pkg/Stream';
import { exitDuperbrowseDone } from '@wix/da-shared-react/pkg/Duperbrowse/redux/actionCreators';
import { appMounted } from '@wix/da-shared-react/pkg/redux/app/actions';
import { fetchPageStreamNext } from '../actions/facet';
import {
  getBiView,
  getComponent,
  getPageViewData,
} from '../selectors/biLogger';
import { getIsCurrentStreamEmpty } from '../selectors/stream';
import {
  getTopicTypeAndItemIds,
  getPageBiMetadata,
  getRequestPageType,
} from '../selectors/facet';
import { biFetchMoreItems } from '../actions/bi';
import { getIsNetworkBarPage } from '../selectors/app';

export function* pageViewHandler() {
  const isNetworkBar = yield select(getIsNetworkBarPage);

  if (isNetworkBar) {
    const pageViewData = yield select(getPageViewData);
    yield put(logPageView(pageViewData));
    return;
  }

  const component = yield select(getComponent);
  const biView = yield select(getBiView);
  const pageBiMetadata = yield select(getPageBiMetadata);
  const topicTypeAndItemIds = yield select(getTopicTypeAndItemIds);

  const pageType = yield select(getRequestPageType);
  let is_empty_state_view: 1 | 0 | undefined;
  if (['deviants-you-watch', 'posts'].includes(pageType)) {
    const isCurrentStreamEmpty = yield select(getIsCurrentStreamEmpty);
    is_empty_state_view = isCurrentStreamEmpty ? 1 : 0;
  }

  yield put(
    logPageView({
      component,
      view: biView,
      ...topicTypeAndItemIds,
      ...(pageBiMetadata && { metadata: pageBiMetadata }),
      is_empty_state_view,
    })
  );
}

export function* infiniteScrollHandler() {
  const offset = yield select(selectors.getTotalItemsCount);
  const event: BIEventData = {
    evid: BiEventType.SCROLL_TO_LOAD_MORE,
    offset,
  };

  yield call(logBiEvent, event);
}

export default function* biLogger() {
  yield all([
    takeEvery([appMounted, exitDuperbrowseDone], pageViewHandler),
    takeEvery(biFetchMoreItems, infiniteScrollHandler),
    takeEvery(fetchPageStreamNext, infiniteScrollHandler),
  ]);
}
